// @flow
import * as React from 'react';
import classNames from 'classnames';

import styles from './Highlight.module.scss';;


/** ***********
 *  пример использования
 *
  <Highlight className={styles.highlight}>
    <HighlightHeader>
      {'Доставка'}
    </HighlightHeader>
    <p>
      <b>Доставка курьером:</b>
      <Dipper> 20–21 января</Dipper>
      {' — от 300 ₽'}
    </p>
    <p>
      <b>Самовывоз:</b>
      <Dipper> 20–21 января</Dipper>
      {' — '}
      <Green>бесплатно</Green>
    </p>
  </Highlight>
*/

type Props = {
  children: React.Node,
  className?: string,
}

const Highlight = ({ children, className }: Props) => (
  <div className={classNames(styles.root, className)}>
    <div className={styles.block}>
      {children}
    </div>
  </div>
);

export default Highlight;
